import { render, staticRenderFns } from "./PaginationLink.vue?vue&type=template&id=30beb8c2&scoped=true"
import script from "./PaginationLink.vue?vue&type=script&lang=js"
export * from "./PaginationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30beb8c2",
  null
  
)

export default component.exports